import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tippy from '@tippy.js/react';
import useGatewayUserCapability from 'sharedHooks/useGatewayUserCapability';
import { assetTypes } from '../constants';
import { IconInfo } from 'svgIcons/MotionPortalIcons';

const DrivesListHeaderComponent = ({ assetType, gatewayConnectedDriveData }) => {
    const { t: translate } = useTranslation();
    const userCapability = useGatewayUserCapability();
    const hasDriveAdminCapability = userCapability.hasDriveAdminCapability();

    const hasMotorAssets = gatewayConnectedDriveData?.some(asset => asset?.assetType === assetTypes.MOTOR || asset?.assetType === assetTypes.GENERIC_MACHINE);

    const renderNodeId = () => {
        if (assetType === assetTypes.DRIVE) {
            return <div className='drives-list__cell' id='drives-list-asset-node-id'>
                {translate('ABB.Powertrain.Frontend.drivesDataNodeID')}
            </div>;
        } else if (assetType === assetTypes.SMART_SENSOR) {
            return null;
        }
    };

    return (
        <div className='drives-list__header'>
            <div className='drives-list__cell drives-list__cell--sticky' id='drives-list-asset-name'>{translate('ABB.Powertrain.Frontend.drivesDataAssetName')}</div>
            <div className='drives-list__cell' id='drives-list-asset-connection-status'>
                {translate('ABB.Powertrain.Frontend.drivesDataConnectionStatus')}
            </div>
            <div className='drives-list__cell' id='drives-list-asset-signal-received'>
                {translate('ABB.Powertrain.Frontend.drivesDataLastCommunication')}
            </div>
            {hasMotorAssets && <>
                <div className='drives-list__cell' id='drives-list-asset-signal-strength'>
                    <div className='header-info-wrapper'>
                        {translate('ABB.Powertrain.Frontend.gatewayDataSignalStrength')}
                        <Tippy
                            content={translate('ABB.Powertrain.Frontend.gatewaySignalStrengthInfoMessage')}
                            interactive={true}
                            interactiveBorder={10}
                            animation='scale'
                            theme='light-border'
                            trigger='click'
                            placement='top'
                            popperOptions={{
                                modifiers: {
                                    preventOverflow: {
                                        escapeWithReference: true
                                    }
                                }
                            }}
                            appendTo={document.body}>
                            <button className='info-icon-clickable' onClick={(e) => e.stopPropagation()}>
                                <IconInfo />
                            </button>
                        </Tippy>
                    </div>
                </div>
                <div className='drives-list__cell' id='drives-list-asset-battery-status'>
                    <div className='header-info-wrapper'>
                        {translate('ABB.Powertrain.Frontend.gatewayDataSensorBatteryStatus')}
                    </div>
                </div>
            </>}

            {renderNodeId()}
            <div className={`drives-list__cell drives-list__cell--sticky-right ${!hasDriveAdminCapability ? 'drives-list__cell--width' : ''}`} id='drives-list-asset-action'>

            </div>
        </div>
    );
};

DrivesListHeaderComponent.propTypes = {
    assetType: PropTypes.string,
    gatewayConnectedDriveData: PropTypes.array,
};

export default DrivesListHeaderComponent;
